module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-30@2x-16a3a64e0bf5021f9e96ae494323a973.png";